<template>
    <div class="goback container">
        <button @click="goBack">
            <svg xmlns="http://www.w3.org/2000/svg" width="67" height="25" viewBox="0 0 67 25">
                <text id="_voltar" data-name="&lt; voltar" transform="translate(0 19)" fill="#aeaeae" font-size="18" font-family="Poppins-Regular, Poppins"><tspan x="0" y="0">&lt; {{ $t('back') }}</tspan></text>
            </svg>
        </button>
    </div>
</template>
<script>
export default {
    methods: {
        goBack() {
            if(localStorage.getItem('token')) {
                this.$router.go();
            } else {
                this.$router.push('/');
            }
        }
    },
}
</script>
<style lang="scss">
.goback {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 50px 0;
    button {
        height: 50px;
        width: 131px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        border: 2px solid #AEAEAE;
        border-radius: 10px;
        cursor: pointer;
        &:hover {
            background-color: #AEAEAE;
            svg {
                text {
                    fill: #fff;
                }
            }
        }
    }
}
</style>